var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayIconTiktok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0004 21.6004C17.3023 21.6004 21.6004 17.3023 21.6004 12.0004C21.6004 6.69846 17.3023 2.40039 12.0004 2.40039C6.69846 2.40039 2.40039 6.69846 2.40039 12.0004C2.40039 17.3023 6.69846 21.6004 12.0004 21.6004ZM11.466 8.60193C11.0978 8.35645 10.6244 8.33356 10.2342 8.54238C9.84397 8.75121 9.60039 9.15784 9.60039 9.60039V14.4004C9.60039 14.8429 9.84397 15.2496 10.2342 15.4584C10.6244 15.6672 11.0978 15.6443 11.466 15.3989L15.066 12.9989C15.3999 12.7763 15.6004 12.4016 15.6004 12.0004C15.6004 11.5992 15.3999 11.2245 15.066 11.0019L11.466 8.60193Z",
    fill: "#07070C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayIconTiktok);
export default __webpack_public_path__ + "static/media/play-icon-tiktok.3b66fd83a9bb7c45d23dd54fdce6b69b.svg";
export { ForwardRef as ReactComponent };